import { Component, ViewEncapsulation, Injectable } from "@angular/core";
import {
  GridOptions,
  ExcelStyle,
  ChartOptionsChanged,
  Module,
  ColDef,
  ChartCreated,
  ChartDestroyed,
  ChartRangeSelectionChanged,
  GridReadyEvent,
  SideBarDef,
} from "ag-grid-community";
import $ from "jquery";

import "jqueryui";
import { DatePipe } from "@angular/common";
import { ActivatedRoute } from "@angular/router";
import { HeaderGroupComponent } from "../header-group-component/header-group.component";
import { ActionRendererComponent } from "../actionsRenderer/action.component";
import { AlarmRendererComponent } from "../alarmRenderer/alarmRenderer.component";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import { DateTimeAdapter } from "ng-pick-datetime";

import {
  NgbModal,
  NgbModalConfig,
  NgbDate,
  NgbCalendar,
  NgbDateStruct,
} from "@ng-bootstrap/ng-bootstrap";
import { HttpService } from "../../service/HTTPService/HttpService";
import { BindingURLService } from "../../service/Bindingurlservice/binding-url.service";
import { Globals } from "../../globals";
import { DetailedSiteListRendererComponent } from "../detailedSiteListRenderer/detailedSiteListRenderer.component";
import { AdditionalDetailsRendererComponent } from "../additionalDetailsRenderer/additionalDetailsRenderer.component";
import { ApiService } from "../../service/apiUrls/apiUrl.service";
import { openModalService } from "../../service/ModalService/ModalService";
import { GroupedHeaderervice } from "../../service/GroupingHeaders/groupheader.service";
import { UserSettingDataService } from "../../service/userSettingDataService/userSettingData.service";
const FileSaver = require("file-saver");
@Component({
  templateUrl: "./alarms.component.html",
  styleUrls: ["./alarms.css"],
  encapsulation: ViewEncapsulation.None,
})
@Injectable()
export class AlarmsComponent {
  disableXlsExport: boolean = false;
  showCountLoader: boolean = false;
  showGridLoader: boolean = false;
  recordsPerRequest;
  pageIndex = 1;
  gridOptions: GridOptions;
  gridApi;
  gridColumnApi;
  disableExport;
  paginationPageSize;
  paginationNumberFormatter;
  public showGrid: boolean;
  public rowData: any[];
  columnDefs: any[];
  public rowCount: string;
  context;
  headers: any = [];
  gridData: any[] = [];
  searchRegion: any[];
  searchRegion1: any[];
  selectedRegion: any[] = [];
  selectedCluster: any[] = [];
  searchCluster: any[];
  searchCluster1: any[];
  searchZone: any[];
  searchZone1: any[];
  selectedZone: any[] = [];
  searchSite: any[];
  searchSite1: any[];
  selectedSite: any[] = [];
  searchSiteClass: any[];
  selectedSiteClass: any[] = [];
  searchCoolingClass: any[];
  selectedCoolingClass: any[] = [];
  searchEnergyClass: any[];
  selectedEnergyClass: any[] = [];
  searchAlarmList: any[];
  selectedAlarm: any[] = [];
  public modules: Module[];
  interval: any;
  searchSiteType: any[];
  selectedSiteType: any[] = [];
  selectedCategoryType: any[] = [];
  selectedSeverity: any[] = [];
  searchSeverity: any = [
    { id: "3", severity: "Critical" },
    { id: "2", severity: "Major" },
    { id: "1", severity: "Minor" },
  ];
  searchAlrmDispMode: any[] = [
    { id: "1", mode: "Open" },
    { id: "0", mode: "Close" },
    { id: "2", mode: "All" },
  ];
  selectedAlrmDispMode: any[];
  startDt = "";
  endDt = "";
  openAlrmCount: number = 0;
  criticalAlarmCount: number = 0;
  majorAlarmCount: number = 0;
  minorAlarmCount: number = 0;
  outageAlrmCount: number = 0;
  recentAlrmCount: number = 0;
  totalAlarmCount: number = 0;
  recordSize = "";
  pageNumber = "";
  frameworkComponents;
  closeResult: string;
  alerts: any[] = [];
  filterSearchList: any[] = [];
  public show_dialog: boolean = true;
  public button_name: string = "fa fa-angle-down";
  fieldsCounter: any[] = [];
  additionalFieldLabel = "Need More ?";
  cannotAdd = "";
  alarmsRecordSize;
  additionalFieldFilter: any[] = [];
  selectedadditonalFields: any[] = [];
  selectedadditonalFieldsFilter: any[] = [];
  selectedadditonalFieldsVal: any[] = [];
  searchPowersource: any[];
  selectedPowersource: any[] = [];
  maxDate: NgbDateStruct;
  minDate: NgbDateStruct;
  hoveredDate: NgbDate;
  fromDate;
  toDate;
  regionIdFrmDashboard = "";
  alarmsStatusID;
  statusFrmDashboard = "";
  actualstatusFrmDashboard = "";
  dateRange = "";
  additionalFields: any[] = [];
  newAlarms: Map<string, any> = new Map();
  presentTime;
  toDateTime;
  fromDateTime;
  hoursValues;
  disablelastbutton = false;
  modeFrmDashboard;
  public domLayout: "normal" | "autoHeight" | "print" = "autoHeight";
  alarmsIdsArray: any = [];
  alarmsIDs;
  cardcount;
  alarmsNameSearch = "";
  lastPageFound;
  PageSize;
  currentPage;
  totalPage;
  totalRowCount;
  public defaultColDef: ColDef;
  datetimeformat = "dd-MM-yyyy,HH:mm:ss";
  intervalfilter;
  totalcount;
  fromPageIndex = 0;
  firstRecordSize = 0;
  gridData1;
  gridDataLength;
  colorIndex;
  colors;
  maxUpdatedDate;
  recentAlarms = "";
  outageAlarms = "";
  alarmFmID = "300";
  countFmID = 302;
  alarmURL = "";
  countURL = "";
  categoryName: any[] = [];
  searchAlarmListAll: any[] = [];
  jsonTitle;
  public popupParent: HTMLElement = document.body;
  showRecords = [
    { id: "10", value: "10" },
    { id: "20", value: "20" },
    { id: "50", value: "50" },
    { id: "100", value: "100" },
    { id: "200", value: "200" },
  ];
  selectedSortBy = undefined;
  sortByFilter = [
    {
      id: "ASC",
      name: "ASC",
    },
    {
      id: "DESC",
      name: "DESC",
    },
  ];
  selectedOrder;
  groupHeaders;
  public sideBar: SideBarDef | string | string[] | boolean | null = {
    toolPanels: [
      {
        id: "columns",
        labelDefault: "Columns",
        labelKey: "columns",
        iconKey: "columns",
        minWidth: 225,
        maxWidth: 225,
        width: 225,
        toolPanel: "agColumnsToolPanel",
        toolPanelParams: {
          suppressRowGroups: true,
          suppressValues: true,
          suppressPivots: true,
          suppressPivotMode: true,
        },
      },
      {
        id: "filters",
        labelDefault: "Filters",
        labelKey: "filters",
        iconKey: "filter",
        toolPanel: "agFiltersToolPanel",
        minWidth: 180,
        maxWidth: 400,
        width: 250,
      },
    ],
  };
  orderByData = [
    {
      arrayID: "2",
      headerTooltip: "Site ID",
    },
    {
      arrayID: "3",
      headerTooltip: "Site Name",
    },
    { arrayID: "4", headerTooltip: "Alarm Name" },
    { arrayID: "5", headerTooltip: "Generated On" },
    { arrayID: "6", headerTooltip: "Closed At" },
    { arrayID: "7", headerTooltip: "Time Elapsed" },
  ];
  userSettings;
  refreshRate;
  constructor(
    private http: HttpService,
    private globals: Globals,
    private datePipe: DatePipe,
    private modalService: NgbModal,
    config: NgbModalConfig,
    private calendar: NgbCalendar,
    private readonly route: ActivatedRoute,
    private urlAuthentication: BindingURLService,
    private apiUrl: ApiService,
    private openModalService: openModalService,
    private groupHeader: GroupedHeaderervice,
    dateTimeAdapter: DateTimeAdapter<any>,
    private userSettingService: UserSettingDataService,
  ) {
    dateTimeAdapter.setLocale("en-IN");
    this.countFmID = 302;
    this.countURL = this.apiUrl.alarmCountLastStatus;
    config.backdrop = "static";
    this.selectedOrder = ["5"];
    this.selectedSortBy = this.sortByFilter[1].id;

    this.userSettingService.getUserSettings().subscribe((settings) => {
      if (settings) {
        this.userSettings = settings;
        this.refreshRate = this.userSettings.userRefreshInterval;

        this.selectedAlrmDispMode =
          this.userSettings.userAlarmDisplayMd.toString();
      }
    });

    let d = new Date();
    this.maxUpdatedDate = new Date();
    this.gridData = [];
    this.gridData1 = [];
    this.filterSearchList = [];
    this.toDateTime = this.datePipe.transform(d, "dd-MM-yyyy HH:mm:ss");

    this.alarmsRecordSize = this.showRecords[0].id;
    this.recordsPerRequest = this.showRecords[0].id;
    this.defaultColDef = {
      wrapText: true,
      enableValue: true,
      enablePivot: true,
      sortable: true,
      filter: true,
      resizable: true,
      flex: 1,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      headerComponent: "sortableHeaderComponent",
      headerComponentParams: {
        menuIcon: "fa-bars",
      },
    };

    this.paginationPageSize = this.showRecords[0].id;
    this.presentTime = this.calendar.getToday();
    if (this.route.snapshot.queryParamMap.get("e")) {
      localStorage.removeItem("Filters");
      this.gridData = [];
      this.gridData1 = [];
      const queryStrings = JSON.parse(
        window.atob(this.route.snapshot.queryParamMap.get("e")),
      );

      this.regionIdFrmDashboard = queryStrings.regId;
      const regionIdFrmDashboard = queryStrings.regId;
      this.statusFrmDashboard = queryStrings.alarmType;
      this.modeFrmDashboard = queryStrings.alarmTypeMode;
      this.alarmsStatusID = queryStrings.svrtId;

      this.alarmsNameSearch = queryStrings.alarmNamesSearch;
      if (
        this.alarmsStatusID != undefined &&
        this.regionIdFrmDashboard == undefined &&
        this.alarmsNameSearch == undefined
      ) {
        this.searchSend1(this.alarmsStatusID);
      } else if (this.alarmsNameSearch != undefined && this.alarmsStatusID) {
        let reqAlarms = {
          fmID: 309,
          MeterSlaveID: "1",
          Accountflag: "1",
          Filter: 1,
        };
        this.http
          .post(
            this.urlAuthentication.alarmLogUrl +
              this.apiUrl.getalarmGenericData,
            reqAlarms,
          )
          .subscribe((res) => {
            this.searchAlarmList = res.response[0].data;
            let i = 0;
            this.searchAlarmList.forEach((element) => {
              if (element.Alarmname == this.alarmsNameSearch) {
                this.selectedAlarm.push(element.Alarmpin);
              }
            });
            this.showGridLoader = true;
            this.searchFun();
          });
      } else if (
        regionIdFrmDashboard != "" &&
        this.statusFrmDashboard != "" &&
        this.modeFrmDashboard
      ) {
        this.actualstatusFrmDashboard = "";
        if (this.statusFrmDashboard == "Critical") {
          this.actualstatusFrmDashboard = "3";
        } else if (this.statusFrmDashboard == "Major") {
          this.actualstatusFrmDashboard = "2";
        } else if (this.statusFrmDashboard == "Minor") {
          this.actualstatusFrmDashboard = "1";
        }
        if (this.modeFrmDashboard == "Open") {
          this.modeFrmDashboard = "1";
        } else if (this.modeFrmDashboard == "Close") {
          this.modeFrmDashboard = "0";
        } else if (this.modeFrmDashboard == "All") {
          this.modeFrmDashboard = "2";
        }
        this.searchSeverity = [
          { id: "3", severity: "Critical" },
          { id: "2", severity: "Major" },
          { id: "1", severity: "Minor" },
        ];
        let reqReg = {
          fmID: 10002,
        };
        this.http
          .genericApi(this.urlAuthentication.genericApiUrl, reqReg)
          .subscribe((resp) => {
            $("#loader").removeClass("loading");
            let regionList = resp.response[0].Data;
            this.searchRegion = regionList.filter(
              (item) => item.RegionID && item.RegionName,
            );
            const regid = this.regionIdFrmDashboard;
            const severity = this.actualstatusFrmDashboard;
            const alarmMode = this.modeFrmDashboard;
            if (
              this.regionIdFrmDashboard &&
              this.actualstatusFrmDashboard &&
              this.modeFrmDashboard
            ) {
              const index = this.searchRegion.findIndex(function (item) {
                return item.RegionID == regid;
              });
              const index1 = this.searchSeverity.findIndex(function (item) {
                return item.id == severity;
              });
              const index2 = this.searchAlrmDispMode.findIndex(function (item) {
                return item.id == alarmMode;
              });
              if (index > -1 && index1 > -1 && index2 > -1) {
                this.selectedSeverity.push(this.searchSeverity[index1].id);
                this.selectedRegion.push(this.searchRegion[index].RegionID);
                if (this.selectedAlrmDispMode.length == 0) {
                  this.selectedAlrmDispMode.push(
                    this.searchAlrmDispMode[index2].id,
                  );
                }

                var searchRegion = this.searchRegion.find(
                  (x) => x.RegionID == this.selectedRegion,
                );

                if (this.selectedRegion.length > 0) {
                  if (this.selectedRegion.length == 1) {
                    var searchRegion = this.searchRegion.find(
                      (x) => x.RegionID == this.selectedRegion,
                    );
                    this.filterSearchList.push({
                      id: 2,
                      name: "Region",
                      value: searchRegion.RegionName,
                    });
                  } else {
                    const existingItem = this.filterSearchList.find(
                      (item) =>
                        item.id === 2 &&
                        item.name === "Region" &&
                        item.value ===
                          "Selected " + this.selectedRegion.length + " values",
                    );

                    if (!existingItem) {
                      this.filterSearchList.push({
                        id: 2,
                        name: "Region",
                        value:
                          "Selected " + this.selectedRegion.length + " values",
                      });
                    }
                  }
                }
                var searchSeverity = this.searchSeverity.find(
                  (x) => x.id == this.selectedSeverity,
                );
                this.filterSearchList.push({
                  id: 5,
                  name: "Severity",
                  value: searchSeverity.severity,
                });
                var searchalrmMode = this.searchAlrmDispMode.find(
                  (x) => x.id == this.selectedAlrmDispMode,
                );
                this.filterSearchList.push({
                  id: 6,
                  name: "Alarm Display Mode",
                  value: searchalrmMode.mode,
                });
              }
              this.showGridLoader = true;
              this.searchFun();
            }
          });
      } else if (regionIdFrmDashboard) {
        this.searchSeverity = [
          { id: "3", severity: "Critical" },
          { id: "2", severity: "Major" },
          { id: "1", severity: "Minor" },
        ];
        let reqReg = {
          fmID: 10002,
        };
        this.http
          .genericApi(this.urlAuthentication.genericApiUrl, reqReg)
          .subscribe((resp) => {
            let regionList = resp.response[0].Data;
            this.searchRegion = regionList.filter(
              (item) => item.RegionID && item.RegionName,
            );
            const index = this.searchRegion.findIndex(
              (item) => item.RegionID == this.regionIdFrmDashboard,
            );

            if (index > -1 && this.regionIdFrmDashboard) {
              this.selectedRegion.push(this.searchRegion[index].RegionID);
              this.showGridLoader = true;
              this.searchFun();
            }
          });
      }
    } else {
      this.showGridLoader = true;
    }

    this.maxDate = calendar.getToday();
    this.fromDate = calendar.getToday();
    this.context = { componentParent: this };
    this.paginationNumberFormatter = function (params) {
      return "[" + params.value.toLocaleString() + "]";
    };

    this.frameworkComponents = {
      actionRenderer: ActionRendererComponent,
      alarmRenderer: AlarmRendererComponent,
      detailedSiteList: DetailedSiteListRendererComponent,
      additionalDetails: AdditionalDetailsRendererComponent,
    };
    this.gridOptions = <GridOptions>{
      context: {
        componentParent: this,
        wrapHeaderText: true,
        autoHeaderHeight: true,
      },
    };

    this.gridOptions.suppressColumnVirtualisation = true;

    if (this.refreshRate) {
      this.interval = setInterval(() => {
        this.firstRecordSize = 0;
        this.gridData = [];
        this.gridData1 = [];
        this.clearGridData = 1;
        this.searchFun();
      }, this.refreshRate);
    } else {
      this.interval = setInterval(() => {
        this.firstRecordSize = 0;
        this.clearGridData = 1;
        this.gridData = [];
        this.gridData1 = [];
        this.searchFun();
      }, 180000);
    }
  }

  ngBeforeViewInit() {
    if (this.globals.message != "" && this.globals.messageType != "") {
      this.alerts = [];
      this.alerts.push({
        type: this.globals.messageType,
        message: this.globals.message,
      });
    }
  }
  close(alert) {
    this.alerts.splice(this.alerts.indexOf(alert), 1);
  }
  toggle() {
    this.show_dialog = !this.show_dialog;
    if (this.show_dialog) {
      this.button_name = "fa fa-angle-down";
    } else {
      this.button_name = "fa fa-angle-up";
    }
  }

  datetimeformate(params) {
    if (params.value != "" && this.datetimeformat != undefined) {
      var date = new Date(params.value);
      if (this.datetimeformat.includes("tt")) {
        this.datetimeformat = this.datetimeformat.replace("tt", "a");
      }
      if (this.datetimeformat.includes("Decimal")) {
        this.datetimeformat = this.datetimeformat.replace(
          "HH:mm(Decimal)",
          "HH:mm",
        );
      }
      let fomateddate = this.datePipe.transform(date, this.datetimeformat);

      return fomateddate;
    }
  }
  removeFilter(filterName) {
    var index = this.filterSearchList.findIndex(function (item) {
      return item.name === filterName;
    });
    this.firstRecordSize = 0;
    this.gridData = [];
    if (index < 1) {
      this.firstRecordSize = 0;
      this.gridData = [];
      window.open("#/106", "_self");
    }
    if (index > -1) {
      this.filterSearchList.splice(index, 1);
      if (filterName == "More Filters") {
        this.selectedadditonalFields.length = 0;
        this.selectedadditonalFieldsFilter.length = 0;
        this.selectedadditonalFieldsVal.length = 0;
        this.fieldsCounter.length = 0;
        if (this.fieldsCounter.length == 0) {
          this.additionalFieldLabel = "Need More ?";
          this.cannotAdd = "";
          this.selectedadditonalFields = [];
          this.selectedadditonalFieldsFilter = [];
          this.selectedadditonalFieldsVal = [];
        }
      }
      if (filterName == "Region") {
        this.selectedRegion = [];
      } else if (filterName == "Zone") {
        this.selectedZone = [];
      } else if (filterName == "Cluster") {
        this.selectedCluster = [];
      } else if (filterName == "Severity") {
        this.selectedSeverity = [];
      } else if (filterName == "Alarm Display Mode") {
        this.selectedAlrmDispMode = [];
      } else if (filterName == "Site Type") {
        this.selectedSiteType = [];
      } else if (filterName == "Alarm Category") {
        this.selectedCategoryType = [];
        this.onCategoryTypeChange();
      } else if (filterName == "Site Classification") {
        this.selectedSiteClass = [];
      } else if (filterName == "Energy Classification") {
        this.selectedEnergyClass = [];
      } else if (filterName == "Cooling Classification") {
        this.selectedCoolingClass = [];
      } else if (filterName == "Alarm") {
        this.selectedAlarm = [];
      } else if (filterName == "Power Source") {
        this.selectedPowersource = [];
      } else if (filterName == "Sort By") {
        this.selectedSortBy = undefined;
      } else if (filterName == "Order By") {
        this.selectedOrder.length = 0;
      } else if (filterName == "Site ID| Site Name") {
        this.selectedSite = [];
      } else if (filterName == "Date Range") {
        if (this.dateRange != undefined) {
          this.dateRange = undefined;
          this.selectedDateRange = undefined;
          this.startDt = undefined;
          this.endDt = undefined;
          this.disableXlsExport = false;
        }
      } else if (filterName == "Recent") {
        this.recentAlarms = "";
      } else if (filterName == "Outage") {
        this.outageAlarms = "";
      }
    }
    if (!this.selectedSortBy || this.selectedOrder.length == 0) {
      this.selectedSortBy = undefined;
      this.selectedOrder.length = 0;
    }
    if (this.filterSearchList.length == 0) {
      this.gridData = [];
      this.gridData1 = [];
      this.rowData = [];
      this.cardDataLastStatus(this.countFmID, this.countURL);
      this.searchFun();
      this.regionIdFrmDashboard = "";
      this.modeFrmDashboard = "";
      this.actualstatusFrmDashboard = "";
    } else {
      this.cardDataLastStatus(this.countFmID, this.countURL);
      this.searchFun();
    }
  }
  addSearchFields() {
    if (this.fieldsCounter.length == 0) {
      this.fieldsCounter.push(0);
      this.selectedadditonalFields = [];
      this.selectedadditonalFieldsFilter = [];
      this.selectedadditonalFieldsVal = [];
      this.additionalFieldLabel = "Add More+";
    } else {
      if (this.fieldsCounter.length < this.additionalFields.length) {
        const val = this.fieldsCounter[this.fieldsCounter.length - 1];
        if (
          this.selectedadditonalFields[val] != undefined &&
          this.selectedadditonalFieldsFilter[val] != undefined &&
          this.selectedadditonalFieldsVal[val] != undefined
        ) {
          this.fieldsCounter.push(val + 1);
          this.additionalFieldLabel = "Add More+";
          const val1 = this.selectedadditonalFields[val];
          const index = this.additionalFields.findIndex(function (item) {
            return item.fieldId == val1;
          });
          this.cannotAdd = "";
        } else {
          this.cannotAdd = "Please fill all the fields !!!";
        }
      } else {
        this.additionalFieldLabel = "";
        this.cannotAdd = "Cannot add more fields !!!";
      }
    }
  }

  removeFields(count, item) {
    const index = this.fieldsCounter.indexOf(count);
    const val1 = this.selectedadditonalFields[index];
    this.selectedadditonalFields.splice(index, 1);
    this.selectedadditonalFieldsFilter.splice(index, 1);
    this.selectedadditonalFieldsVal.splice(index, 1);
    const index1 = this.globals.additionalFields.findIndex(function (item) {
      return item.fieldId == val1;
    });
    if (index1 !== -1) {
      this.additionalFields.splice(index, 0);
    }
    if (this.fieldsCounter.length == 0) {
      this.additionalFieldLabel = "Need More ?";
      this.cannotAdd = "";
      this.selectedadditonalFields = [];
      this.selectedadditonalFieldsFilter = [];
      this.selectedadditonalFieldsVal = [];
    } else {
      this.additionalFieldLabel = "Add More+";
      this.cannotAdd = "";
    }
  }
  exportFromDate;
  exportToDate;
  expStartDt;
  expToDt;
  onSelectStartDate(date: NgbDate) {
    const stdate = new Date(date.year, date.month - 1, date.day);
    this.minDate = new NgbDate(date.year, date.month - 1, date.day);
    this.exportFromDate = this.datePipe.transform(stdate, "dd-MM-yyyy");
    if (this.exportToDate === "" || this.exportToDate === undefined) {
      this.exportToDate = this.exportFromDate.concat(" 23:59:59");
    }
    this.exportFromDate = this.exportFromDate.concat(" 00:00:00");
  }
  onSelectEndDate(date: NgbDate) {
    const endDate = new Date(date.year, date.month - 1, date.day);
    this.exportToDate = this.datePipe.transform(endDate, "dd-MM-yyyy");
    if (this.exportFromDate === "" || this.exportFromDate === undefined) {
      this.exportFromDate = this.exportToDate.concat(" 00:00:00");
    }
    this.exportToDate = this.exportToDate.concat(" 23:59:59");
  }

  isRegionChecked() {
    return this.searchRegion && this.searchRegion.length > 0;
  }

  autoSizeAll() {
    const allColumnIds: string[] = [];
    this.gridColumnApi.getColumns()!.forEach((column) => {
      allColumnIds.push(column.getId());
    });
    this.gridColumnApi.autoSizeColumns(allColumnIds);
  }
  export: any;
  ngOnInit() {
    this.userSettingService.refreshUserSettings();

    this.gridData = [];
    this.gridData1 = [];
    this.alarmsRecordSize = this.showRecords[0].id;
    this.newAlarms.clear();

    this.gridData = [];
    this.getAlramsCatgeory();
  }

  onRecordSizeChanged() {
    const value = (<HTMLInputElement>document.getElementById("pagesize")).value;
    this.gridApi.paginationSetPageSize(Number(value));
    this.recordSize = this.gridApi.paginationGetPageSize();
    this.pageNumber = this.gridApi.paginationGetCurrentPage();
  }

  categoryList: any[] = [];

  openExportModal(xlsExport: any) {
    this.openModalService.OpenModel(xlsExport, "lg");
  }

  getAlramsCatgeory() {
    const hasQueryParams = !!this.route.snapshot.queryParamMap.get('e');
    let payload = { fmID: 321 };
    this.http
      .post(
        this.urlAuthentication.alarmLogUrl + this.apiUrl.getalarmGenericData,
        payload,
      )
      .subscribe({
        next: (resp) => {
          this.categoryName = resp.response[0].data.map((item: any) => ({
            categoryID: item.categoryID,
            categoryName: `Category-${item.categoryID}`,
          }));
          if (!hasQueryParams) {
            if (this.categoryName.length > 0) {
              this.selectedCategoryType = [this.categoryName[0].categoryID];
            }
            this.searchFun();
          }
        },
        error: (error) => {
          console.error(error);
          if (!hasQueryParams) {
            this.searchFun();
          }
        },
      });
  }
  openSearchModal(content) {
    if (!this.dateRange) {
      this.selectedDateRange = undefined;
      this.fromDate = undefined;
      this.toDate = undefined;
      this.hoveredDate = undefined;
    }
    this.openModalService.OpenModel(content, "lg");

    const siteRequest = {
      fmID: 10000,
    };
    this.http
      .genericApi(this.urlAuthentication.genericApiUrl, siteRequest)
      .subscribe(
        (resp) => {
          this.searchSite = resp.response[0].Data;
          this.searchSite.map((i) => {
            i.siteId_Name = i.SiteCode + " | " + i.SiteName;
            return i;
          });
        },
        (error) => {
          console.error(error);
        },
      );
    const regionReq = {
      fmID: 10002,
    };
    this.http
      .genericApi(this.urlAuthentication.genericApiUrl, regionReq)
      .subscribe(
        (resp) => {
          let regionList = resp.response[0].Data;
          this.searchRegion = regionList.filter(
            (item) => item.RegionID && item.RegionName,
          );
          const regid = this.selectedRegion;
          const index = this.searchRegion.findIndex(function (item) {
            return item["RegionID"] == regid;
          });
          if (index > -1 && this.regionIdFrmDashboard) {
            this.selectedRegion.push(this.searchRegion[index]["RegionID"]);
          }
        },
        (error) => {
          console.error(error);
        },
      );
    const clusterReq = {
      fmID: 10001,
    };
    this.http
      .genericApi(this.urlAuthentication.genericApiUrl, clusterReq)
      .subscribe(
        (resp) => {
          let clusterlist = resp.response[0].Data;
          this.searchCluster = clusterlist.filter(
            (item) => item.ClusterID && item.ClusterName,
          );
        },
        (error) => {
          console.error(error);
        },
      );

    let reqJson = {
      fmID: 10003,
    };
    this.http
      .genericApi(this.urlAuthentication.genericApiUrl, reqJson)
      .subscribe(
        (resp) => {
          this.searchZone = [];
          let searchZonelist = resp.response[0].Data;
          this.searchZone = searchZonelist.filter(
            (item) => item.ZoneID && item.ZoneName,
          );
        },
        (error) => {
          console.error(error);
        },
      );
    let reqEnergy = {
      fmID: 10004,
    };
    this.http
      .genericApi(this.urlAuthentication.genericApiUrl, reqEnergy)
      .subscribe(
        (resp) => {
          this.searchEnergyClass = [];
          let energyClass = resp.response[0].Data;
          this.searchEnergyClass = energyClass.filter(
            (item) => item.ID && item.EnerClassName,
          );
        },
        (error) => {
          console.error(error);
        },
      );
    let reqCool = {
      fmID: 10005,
    };
    this.http
      .genericApi(this.urlAuthentication.genericApiUrl, reqCool)
      .subscribe(
        (resp) => {
          this.searchCoolingClass = [];
          let coolingClass = resp.response[0].Data;
          this.searchCoolingClass = coolingClass.filter(
            (item) => item.ID && item.CoolClassName,
          );
        },
        (error) => {
          console.error(error);
        },
      );
    let reqSiteClass = {
      fmID: 10006,
    };
    this.http
      .genericApi(this.urlAuthentication.genericApiUrl, reqSiteClass)
      .subscribe(
        (resp) => {
          this.searchSiteClass = [];
          let SiteClass = resp.response[0].Data;
          this.searchSiteClass = SiteClass.filter(
            (item) => item.ID && item.SiteClassName,
          );
        },
        (error) => {
          console.error(error);
        },
      );
    let reqSiteType = {
      fmID: 10008,
    };
    this.http
      .genericApi(this.urlAuthentication.genericApiUrl, reqSiteType)
      .subscribe(
        (resp) => {
          this.searchSiteType = [];
          let siteType = resp.response[0].Data;
          this.searchSiteType = siteType.filter(
            (item) => item.id && item.siteType,
          );
        },
        (error) => {
          console.error(error);
        },
      );
    const powerReq = {
      fmID: 10010,
    };
    this.http
      .genericApi(this.urlAuthentication.genericApiUrl, powerReq)
      .subscribe((resp) => {
        this.searchPowersource = [];
        let powersource = resp.response[0].Data;
        this.searchPowersource = powersource.filter(
          (item) => item.id && item.powerSource,
        );
      });

    const categoryAlarm = {
      fmID: 321,
      // MeterSlaveID: "1",
      // Accountflag: "1",
      // Filter: 1,
    };
    this.http
      .post(
        this.urlAuthentication.alarmLogUrl + this.apiUrl.getalarmGenericData,
        categoryAlarm,
      )
      .subscribe(
        (resp) => {
          this.categoryList = resp.response[0].data;
          this.categoryName = resp.response[0].data.map((item: any) => ({
            categoryID: item.categoryID,
            categoryName: `Category-${item.categoryID}`,
          }));
          if (
            this.selectedCategoryType.length === 0 &&
            this.categoryName.length > 0
          ) {
            this.selectedCategoryType = [this.categoryName[0].categoryID];
            this.onCategoryTypeChange();
          }
        },
        (error) => {
          console.error(error);
        },
      );

    const powerReqAlarm = {
      fmID: 309,
      MeterSlaveID: "1",
      Accountflag: "1",
      Filter: 1,
    };
    this.http
      .post(
        this.urlAuthentication.alarmLogUrl + this.apiUrl.getalarmGenericData,
        powerReqAlarm,
      )
      .subscribe(
        (resp) => {
          this.searchAlarmList = resp.response[0].data;
          this.searchAlarmListAll = resp.response[0].data;
          this.onCategoryTypeChange();
        },
        (error) => {
          console.error(error);
        },
      );
  }

  /**
   *
   * @param content  To implement the Search Fun and display the grid data accordingly
   */

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
  }
  onSearchSevarityBases = 0;
  searchSend1(id) {
    this.recentAlarms = "";
    this.outageAlarms = "";
    this.firstRecordSize = 0;
    this.gridData = [];
    this.gridData1 = [];
    this.rowData = [];
    this.disablelastbutton = true;
    this.onSearchSevarityBases = 1;
    this.startDt = undefined;
    this.endDt = undefined;
    this.dateRange = undefined;
    this.fromDate = undefined;
    this.toDate = undefined;
    this.hoveredDate = undefined;
    this.filterSearchList = [];
    this.selectedRegion = [];
    this.selectedZone = [];
    this.selectedCluster = [];
    this.selectedSeverity = [];
    this.selectedSiteType = [];
    this.selectedCategoryType = [];
    this.selectedSiteClass = [];
    this.selectedEnergyClass = [];
    this.selectedCoolingClass = [];
    this.selectedAlarm = [];
    this.selectedSite = [];
    this.fieldsCounter = [];
    this.additionalFieldLabel = "Need More ?";
    this.selectedPowersource = [];
    this.cannotAdd = "";
    this.filterSearchList = [];
    this.gridData = [];
    this.selectedSeverity.push(id);
    this.fromPageIndex = 0;
    this.firstRecordSize = 0;
    this.searchFun();
  }
  searchOpenAlarms() {
    this.recentAlarms = "";
    this.outageAlarms = "";
    this.firstRecordSize = 0;
    this.gridData = [];
    this.gridData1 = [];
    this.rowData = [];
    this.disablelastbutton = true;
    this.startDt = undefined;
    this.endDt = undefined;
    this.dateRange = undefined;
    this.fromDate = undefined;
    this.toDate = undefined;
    this.hoveredDate = undefined;
    this.filterSearchList = [];
    this.selectedRegion = [];
    this.selectedZone = [];
    this.selectedCluster = [];
    this.selectedSeverity = [];
    this.selectedAlrmDispMode = ["1"];
    this.selectedSiteType = [];
    this.selectedCategoryType = [];
    this.selectedSiteClass = [];
    this.selectedEnergyClass = [];
    this.selectedCoolingClass = [];
    this.selectedAlarm = [];
    this.selectedSite = [];
    this.fieldsCounter = [];
    this.additionalFieldLabel = "Need More ?";
    this.selectedPowersource = [];
    this.cannotAdd = "";
    this.filterSearchList = [];
    this.gridData = [];
    this.fromPageIndex = 0;
    this.firstRecordSize = 0;
    this.searchFun();
  }
  searchOutageAlarms() {
    this.recentAlarms = "";
    this.outageAlarms = "1";

    this.firstRecordSize = 0;
    this.gridData = [];
    this.gridData1 = [];
    this.rowData = [];
    this.disablelastbutton = true;
    this.onSearchSevarityBases = 1;
    this.cardcount = this.outageAlrmCount;
    this.startDt = undefined;
    this.endDt = undefined;
    this.dateRange = undefined;
    this.fromDate = undefined;
    this.toDate = undefined;
    this.hoveredDate = undefined;
    this.filterSearchList = [];
    this.selectedRegion = [];
    this.selectedZone = [];
    this.selectedCluster = [];
    this.selectedSeverity = [];
    this.selectedSiteType = [];
    this.selectedCategoryType = [];
    this.selectedSiteClass = [];
    this.selectedEnergyClass = [];
    this.selectedCoolingClass = [];
    this.selectedAlarm = [];
    this.selectedSite = [];
    this.fieldsCounter = [];
    this.additionalFieldLabel = "Need More ?";
    this.selectedPowersource = [];
    this.cannotAdd = "";
    this.filterSearchList = [];

    this.fromPageIndex = 0;
    this.firstRecordSize = 0;
    this.gridData = [];
    this.searchFun();
  }
  searchRecentAlarms() {
    this.recentAlarms = "1";
    this.outageAlarms = "";
    this.firstRecordSize = 0;
    this.gridData = [];
    this.gridData1 = [];
    this.rowData = [];

    this.disablelastbutton = true;
    this.cardcount = this.recentAlrmCount;
    this.startDt = undefined;
    this.endDt = undefined;
    this.dateRange = undefined;
    this.fromDate = undefined;
    this.toDate = undefined;
    this.hoveredDate = undefined;
    this.filterSearchList = [];
    this.selectedRegion = [];
    this.selectedZone = [];
    this.selectedCluster = [];
    this.selectedSeverity = [];
    this.selectedSiteType = [];
    this.selectedCategoryType = [];
    this.selectedSiteClass = [];
    this.selectedEnergyClass = [];
    this.selectedCoolingClass = [];
    this.selectedAlarm = [];
    this.selectedSite = [];
    this.additionalFieldLabel = "Need More ?";
    this.selectedPowersource = [];
    this.cannotAdd = "";
    this.filterSearchList = [];
    let d = new Date();

    this.fromPageIndex = 0;
    this.firstRecordSize = 0;
    this.gridData = [];
    this.gridData1 = [];
    this.searchFun();
  }
  advsearchArr: any[];
  clearGridData;

  exportGrid(type) {
    let exportFmId = 315;
    if (!this.startDt || !this.endDt) {
      exportFmId = 315;
    } else {
      exportFmId = 301;
    }
    this.showGridLoader = true;
    let ExportRequest = {
      fmID: exportFmId,
      FromDateTime: this.startDt ? this.startDt : "",
      ToDateTime: this.endDt ? this.endDt : "",
      RegionID: this.selectedRegion.toString().replace(/[\[\]']+/g, '"'),
      ZoneID: this.selectedZone.toString().replace(/[\[\]']+/g, '"'),
      ClusterID: this.selectedCluster.toString().replace(/[\[\]']+/g, '"'),
      SeverityID: this.selectedSeverity.toString().replace(/[\[\]']+/g, '"'),
      AlarmDisplayMode:
        this.selectedAlrmDispMode.toString().replace(/[\[\]']+/g, '"') == "2"
          ? "1,0"
          : this.selectedAlrmDispMode.toString().replace(/[\[\]']+/g, '"'),
      SiteTypeID: this.selectedSiteType.toString().replace(/[\[\]']+/g, '"'),
      alCategoryID: this.selectedCategoryType
        .toString()
        .replace(/[\[\]']+/g, '"'),
      SiteClassifID: this.selectedSiteClass
        .toString()
        .replace(/[\[\]']+/g, '"'),
      EnergyClassifID: this.selectedEnergyClass
        .toString()
        .replace(/[\[\]']+/g, '"'),
      CoolingClassifID: this.selectedCoolingClass
        .toString()
        .replace(/[\[\]']+/g, '"'),
      AlrID: this.selectedAlarm,
      SiteID: this.selectedSite.toString().replace(/[\[\]']+/g, '"'),
      PowerSource: this.selectedPowersource
        .toString()
        .replace(/[\[\]']+/g, '"'),
      recentflag: this.recentAlarms,
      outageflag: this.outageAlarms,
      Export: type,
      Order: "",
      OrderBy: "",
      Sort: "",
    };
    this.http
      .post(
        this.urlAuthentication.alarmLogUrl + this.apiUrl.AlarmLogExport,
        ExportRequest,
      )
      .subscribe(
        (res) => {
          this.showGridLoader = false;
          const downloadPath =
            this.urlAuthentication.alarmLogUrl + "/" + res.response;
          const link = document.createElement("a");
          link.href = downloadPath;
          link.download = downloadPath.split("/").pop();
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        },
        (error) => {
          this.showGridLoader = false;
          console.error(error);
        },
      );
  }

  calculateRowCount() {
    this.recordSize = "0";
    this.pageNumber = "0";
    if (this.gridOptions.api && this.rowData) {
      const model = this.gridOptions.api.getModel();
      const totalRows = this.rowData.length;
      const processedRows = model.getRowCount();
      this.rowCount =
        processedRows.toLocaleString() + " / " + totalRows.toLocaleString();
    }
  }
  public excelStyles: ExcelStyle[] = [
    {
      id: "dateLong",
      dataType: "DateTime",
      numberFormat: {
        format: "dd/mm/yyy hh:mm:ss",
      },
    },
    {
      id: "greenBackground",
      interior: {
        color: "#b5e6b5",
        pattern: "Solid",
      },
    },
    {
      id: "redFont",
      font: {
        fontName: "Calibri Light",
        underline: "Single",
        italic: true,
        color: "#ff0000",
      },
    },
    {
      id: "darkGreyBackground",
      interior: {
        color: "#888888",
        pattern: "Solid",
      },
      font: {
        fontName: "Calibri Light",
        color: "#ffffff",
      },
    },
    {
      id: "boldBorders",
      borders: {
        borderBottom: {
          color: "#000000",
          lineStyle: "Continuous",
          weight: 3,
        },
        borderLeft: {
          color: "#000000",
          lineStyle: "Continuous",
          weight: 3,
        },
        borderRight: {
          color: "#000000",
          lineStyle: "Continuous",
          weight: 3,
        },
        borderTop: {
          color: "#000000",
          lineStyle: "Continuous",
          weight: 3,
        },
      },
    },
    {
      id: "header",
      font: { size: 14 },
      interior: {
        color: "#b5e6b5",
        pattern: "Solid",
      },
      borders: {
        borderBottom: {
          color: "#5687f5",
          lineStyle: "Continuous",
          weight: 1,
        },
        borderLeft: {
          color: "#5687f5",
          lineStyle: "Continuous",
          weight: 1,
        },
        borderRight: {
          color: "#5687f5",
          lineStyle: "Continuous",
          weight: 1,
        },
        borderTop: {
          color: "#5687f5",
          lineStyle: "Continuous",
          weight: 1,
        },
      },
    },
    {
      id: "bigHeader",
      interior: {
        color: "#519d43",
        pattern: "Solid",
      },

      font: { size: 18, color: "#ffffff" },
      alignment: {
        horizontal: "Center",
        vertical: "Center",
      },
    },
    {
      id: "stringType",
      dataType: "String",
    },
  ];
  onBtnExportDataAsExcel() {
    this.gridApi.exportDataAsExcel();
  }

  public onReady(datas: GridReadyEvent) {
    this.gridApi = datas.api;
    this.gridColumnApi = datas.columnApi;
    this.colorIndex = 0;
    this.colors = ["#000000", "#000066", "#006600", "#660000"];
    function createData(count) {
      var result = [];
      for (var i = 1; i <= count; i++) {
        result.push({
          a: (i * 863) % 100,
          b: (i * 811) % 100,
          c: (i * 743) % 100,
          d: (i * 677) % 100,
          e: (i * 619) % 100,
          f: (i * 571) % 100,
        });
      }
      return result;
    }
    this.calculateRowCount();
  }

  onColumnMoved(event) {
    var columnState = JSON.stringify(event.columnApi.getColumnState());
    localStorage.setItem("myColumnState", columnState);
  }
  validateFloatKeyPress() {
    let e1: any = $("#additionalFieldVal").val();
    var v = parseFloat(e1);
    $("#additionalFieldVal").val(isNaN(v) ? "" : v.toFixed(2));
  }

  selectedDateRange;
  onDateSelection(date) {
    this.selectedDateRange = date;
    if (date != null) {
      this.disableXlsExport = true;
      let frmDate = date[0];
      let endDates = date[1];
      if (endDates == null) {
        Swal.fire({
          text: "Please select date range",
        });
        $("#owldateRange").val("");
        return false;
      } else {
        let finalFromTime = "00" + ":" + "00" + ":" + "00";
        let finalToTime = "23" + ":" + "59" + ":" + "59";
        this.fromDate = new Date(
          frmDate.getFullYear(),
          frmDate.getMonth(),
          frmDate.getDate(),
        );
        this.toDate = new Date(
          endDates.getFullYear(),
          endDates.getMonth(),
          endDates.getDate(),
        );
        if (!this.fromDate && !this.toDate) {
          this.fromDate = frmDate;
        } else if (this.fromDate && this.toDate) {
          this.toDate = date;

          if (frmDate.getMonth() != endDates.getMonth()) {
            Swal.fire({
              text: "Please select date range within a month",
            });
            $("#owldateRange").val("");
            this.fromDate = null;
            this.toDate = null;
          } else {
            const stdate = new Date(
              frmDate.getFullYear(),
              frmDate.getMonth(),
              frmDate.getDate(),
            );
            const endate = new Date(
              endDates.getFullYear(),
              endDates.getMonth(),
              endDates.getDate(),
            );

            this.startDt = this.datePipe.transform(stdate, "dd-MM-yyyy");
            this.endDt = this.datePipe.transform(endate, "dd-MM-yyyy");
            this.dateRange = this.startDt + " - " + this.endDt;
            this.startDt = this.startDt.concat(" " + finalFromTime);
            this.endDt = this.endDt.concat(" " + finalToTime);
          }
        } else {
          this.toDate = null;
          this.fromDate = date;
          const stdate = new Date(
            this.fromDate.year,
            this.fromDate.month - 1,
            this.fromDate.day,
          );
          this.startDt = this.datePipe.transform(stdate, "dd-MM-yyyy");
          const endDate = this.startDt;
          this.dateRange = this.startDt + " - " + this.startDt;
          this.startDt = this.startDt.concat(" " + finalFromTime);
          this.endDt = endDate.concat(" " + finalToTime);
        }
      }
    } else {
      this.disableXlsExport = false;
    }
  }
  date_diff_indays(dt1, dt2) {
    const timeDiff = Math.abs(dt1.getTime() - dt2.getTime());
    const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

    return diffDays;
  }
  isHovered(date: NgbDate) {
    return (
      this.fromDate &&
      !this.toDate &&
      this.hoveredDate &&
      date.after(this.fromDate) &&
      date.before(this.hoveredDate)
    );
  }

  isInside(date: NgbDate) {
    return date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return (
      date.equals(this.fromDate) ||
      date.equals(this.toDate) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }
  changeValues(val) {
    if (val == "zone") {
      this.selectedRegion = undefined;
      this.selectedCluster = undefined;
      this.selectedSite = undefined;
      let SiteClassID = "";
      let EnergyClassID = "";
      let CoolClassID = "";
      let zoneID = this.selectedZone.toString().replace(/[\[\]']+/g, '"');
      let regionID = "";
      let clusterID = "";
      if (this.selectedEnergyClass) {
        EnergyClassID = this.selectedEnergyClass
          .toString()
          .replace(/[\[\]']+/g, '"');
      }
      if (this.selectedCoolingClass) {
        CoolClassID = this.selectedCoolingClass
          .toString()
          .replace(/[\[\]']+/g, '"');
      }
      if (this.selectedSiteClass) {
        SiteClassID = this.selectedSiteClass
          .toString()
          .replace(/[\[\]']+/g, '"');
      }
      if (zoneID) {
        this.loadRegionList(zoneID);
        this.loadClusterList(zoneID, regionID);
        this.loadSiteList(
          zoneID,
          regionID,
          clusterID,
          EnergyClassID,
          CoolClassID,
          SiteClassID,
        );
      } else {
        this.searchRegion = this.searchRegion1;
        this.searchCluster = this.searchCluster1;
        this.searchSite = this.searchSite1;
      }
    } else if (val == "region") {
      let zoneID = "";
      let regionID = "";
      let clusterID = "";
      let SiteClassID = "";
      let EnergyClassID = "";
      let CoolClassID = "";
      if (this.selectedZone) {
        zoneID = this.selectedZone.toString().replace(/[\[\]']+/g, '"');
      }
      if (this.selectedRegion) {
        regionID = this.selectedRegion.toString().replace(/[\[\]']+/g, '"');
      }
      if (this.selectedCluster) {
        clusterID = this.selectedCluster.toString().replace(/[\[\]']+/g, '"');
      }
      if (this.selectedEnergyClass) {
        EnergyClassID = this.selectedEnergyClass
          .toString()
          .replace(/[\[\]']+/g, '"');
      }
      if (this.selectedCoolingClass) {
        CoolClassID = this.selectedCoolingClass
          .toString()
          .replace(/[\[\]']+/g, '"');
      }
      if (this.selectedSiteClass) {
        SiteClassID = this.selectedSiteClass
          .toString()
          .replace(/[\[\]']+/g, '"');
      }
      this.selectedCluster = undefined;
      this.selectedSite = undefined;
      if (regionID) {
        this.loadClusterList(zoneID, regionID);
        this.loadSiteList(
          zoneID,
          regionID,
          clusterID,
          EnergyClassID,
          CoolClassID,
          SiteClassID,
        );
      } else {
        this.loadClusterList(zoneID, regionID);
        this.loadSiteList(
          zoneID,
          regionID,
          clusterID,
          EnergyClassID,
          CoolClassID,
          SiteClassID,
        );
      }
    } else if (val == "cluster") {
      let zoneID = "";
      let regionID = "";
      let clusterID = "";
      let SiteClassID = "";
      let EnergyClassID = "";
      let CoolClassID = "";
      this.selectedSite = undefined;
      if (this.selectedZone) {
        zoneID = this.selectedZone.toString().replace(/[\[\]']+/g, '"');
      }
      if (this.selectedRegion) {
        regionID = this.selectedRegion.toString().replace(/[\[\]']+/g, '"');
      }
      if (this.selectedCluster) {
        clusterID = this.selectedCluster.toString().replace(/[\[\]']+/g, '"');
      }
      if (this.selectedEnergyClass) {
        EnergyClassID = this.selectedEnergyClass
          .toString()
          .replace(/[\[\]']+/g, '"');
      }
      if (this.selectedCoolingClass) {
        CoolClassID = this.selectedCoolingClass
          .toString()
          .replace(/[\[\]']+/g, '"');
      }
      if (this.selectedSiteClass) {
        SiteClassID = this.selectedSiteClass
          .toString()
          .replace(/[\[\]']+/g, '"');
      }
      if (clusterID) {
        this.loadSiteList(
          zoneID,
          regionID,
          clusterID,
          EnergyClassID,
          CoolClassID,
          SiteClassID,
        );
      } else {
        this.loadSiteList(
          zoneID,
          regionID,
          clusterID,
          EnergyClassID,
          CoolClassID,
          SiteClassID,
        );
      }
    } else if ((val = "classification")) {
      let zoneID = "";
      let regionID = "";
      let clusterID = "";
      let SiteClassID = "";
      let EnergyClassID = "";
      let CoolClassID = "";
      this.selectedSite = undefined;
      if (this.selectedZone) {
        zoneID = this.selectedZone.toString().replace(/[\[\]']+/g, '"');
      }
      if (this.selectedRegion) {
        regionID = this.selectedRegion.toString().replace(/[\[\]']+/g, '"');
      }
      if (this.selectedCluster) {
        clusterID = this.selectedCluster.toString().replace(/[\[\]']+/g, '"');
      }
      if (this.selectedEnergyClass) {
        EnergyClassID = this.selectedEnergyClass
          .toString()
          .replace(/[\[\]']+/g, '"');
      }
      if (this.selectedCoolingClass) {
        CoolClassID = this.selectedCoolingClass
          .toString()
          .replace(/[\[\]']+/g, '"');
      }
      if (this.selectedSiteClass) {
        SiteClassID = this.selectedSiteClass
          .toString()
          .replace(/[\[\]']+/g, '"');
      }
      if (EnergyClassID || CoolClassID || SiteClassID) {
        this.loadSiteList(
          zoneID,
          regionID,
          clusterID,
          EnergyClassID,
          CoolClassID,
          SiteClassID,
        );
      } else {
        this.loadSiteList(
          zoneID,
          regionID,
          clusterID,
          EnergyClassID,
          CoolClassID,
          SiteClassID,
        );
      }
    }
  }

  loadRegionList(zoneID) {
    let setJson = {
      fmID: 10002,
      zoneID: zoneID,
    };
    this.http
      .genericApi(this.urlAuthentication.genericApiUrl, setJson)
      .subscribe(
        (resp) => {
          let regionList = resp.response[0].Data;
          this.searchRegion = regionList.filter(
            (item) => item.RegionID && item.RegionName,
          );
        },
        (error) => {
          console.error(error);
        },
      );
  }
  loadClusterList(zoneID, regionID) {
    let setJson = {
      fmID: 10001,
      zoneID: zoneID,
      regionID: regionID,
    };
    this.http
      .genericApi(this.urlAuthentication.genericApiUrl, setJson)
      .subscribe(
        (resp) => {
          let clusterlist = resp.response[0].Data;
          this.searchCluster = clusterlist.filter(
            (item) => item.ClusterID && item.ClusterName,
          );
        },
        (error) => {
          console.error(error);
        },
      );
  }
  loadSiteList(
    zoneID,
    regionID,
    clusterID,
    EnergyClassID,
    CoolClassID,
    SiteClassID,
  ) {
    const siteRequest = {
      fmID: 10000,
      zoneID: zoneID,
      regionID: regionID,
      clusterID: clusterID,
      siteClassID: SiteClassID,
      energyClassifID: EnergyClassID,
      coolingClassifID: CoolClassID,
    };
    this.http
      .genericApi(this.urlAuthentication.genericApiUrl, siteRequest)
      .subscribe(
        (resp) => {
          this.searchSite = resp.response[0].Data;
          this.searchSite.map((i) => {
            i.siteId_Name = i.SiteCode + " | " + i.SiteName;
            return i;
          });
        },
        (error) => {
          console.error(error);
        },
      );
  }

  downloadPdf() {
    let getDataJson = {
      PageIndex: 0,
      RecordPerPage: 0,
      RegionID: this.regionIdFrmDashboard,
      SeverityID: this.actualstatusFrmDashboard,
      AlarmDisplayMode: this.modeFrmDashboard,
      Datetimenow: this.toDateTime,
      PDF: 1,
    };
    this.http
      .post(
        this.urlAuthentication.itocUrl + this.apiUrl.alarmGridUrl,
        getDataJson,
      )
      .subscribe((res) => {
        const getImgResp: string = JSON.stringify(res.body);
        const resp = JSON.parse(getImgResp);
        if (resp.Status == "1") {
          FileSaver.saveAs(
            this.urlAuthentication.itocUrl + "PDFReports/" + resp.Message,
          );
        } else {
          alert(resp.Message);
        }
      });
  }

  onPaginationChanged() {
    if (this.gridApi) {
      this.lastPageFound = this.gridApi.paginationIsLastPageFound();
      this.PageSize = this.gridApi.paginationGetPageSize();
      this.currentPage = this.gridApi.paginationGetCurrentPage() + 1;
      this.totalPage = this.gridApi.paginationGetTotalPages();
      this.totalRowCount = this.gridApi.getDisplayedRowCount();
    }
  }

  redrawAllRows() {
    this.progressColor();
    this.gridApi.redrawRows();
  }

  redrawTopRows() {
    this.progressColor();
    var rows = [];
    for (var i = 0; i < 6; i++) {
      var row = this.gridApi.getDisplayedRowAtIndex(i);
      rows.push(row);
    }
    this.gridApi.redrawRows({ rowNodes: rows });
  }
  progressColor() {
    this.colorIndex++;
    if (this.colorIndex === this.colors.length) {
      this.colorIndex = 0;
    }
  }

  SaveAlarmGridSettingsCol() {
    let unselectedColumns = [];
    let pinnedArr = [];
    const columnVal = this.gridColumnApi.getAllGridColumns();

    columnVal.forEach((element) => {
      if (element.visible == false) {
        if (!(element.colId == "action")) {
          unselectedColumns.push({
            arrayID: element.colId.toString().split("_")[0],
            hide: element.visible === false ? "true" : "false",
            headerName: element.userProvidedColDef.field,
            headerTooltip: element.userProvidedColDef.headerTooltip,
          });
        }
      }
      if (element.visible == true) {
        if (!(element.colId == "action")) {
          if (element.pinned !== null) {
            pinnedArr.push({
              arrayID: element.colId.toString().split("_")[0],
              pinned: element.pinned,
              headerName: element.userProvidedColDef.field,
              headerTooltip: element.userProvidedColDef.headerTooltip,
            });
          }
        }
      }
    });

    const getDataJson = {
      fmID: this.alarmFmID,
      title: this.jsonTitle,
      unselectedColumns: unselectedColumns,
      pinnedColumns: pinnedArr,
    };
    this.http
      .post(
        this.urlAuthentication.crudApiUrl + this.apiUrl.saveSettingsUrl,
        getDataJson,
      )
      .subscribe((response) => {
        const resp = response;
        if (resp) {
          this.headers = [];
          this.columnDefs = [];
          this.searchFun();
          this.gridApi.setFilterModel(null);
          Swal.fire({
            text: "Setting Saved Successfully",
            icon: "success",
          });
        }
      });
  }

  ngAfterViewInit() {}
  onPageSizeChanged() {
    this.gridData = [];
    this.gridData1 = [];
    this.rowData = [];
    this.pageIndex = 1;

    this.recordsPerRequest = Number(this.alarmsRecordSize);
    this.searchFun();
    this.showGridLoader = true;
    this.gridApi.paginationSetPageSize(this.alarmsRecordSize);
  }

  ngAfterViewChecked() {
    $("span.ag-paging-page-summary-panel").addClass("remi");
  }

  onChartCreated(event: ChartCreated) {}

  onChartRangeSelectionChanged(event: ChartRangeSelectionChanged) {}

  onChartOptionsChanged(event: ChartOptionsChanged) {}

  onChartDestroyed(event: ChartDestroyed) {}
  ngOnDestroy() {
    this.modalService.dismissAll();
    if (this.interval) {
      clearInterval(this.interval);
    }
    if (this.intervalfilter) {
      clearInterval(this.intervalfilter);
    }
    $(".ag-paging-page-summary-panel").removeClass("remi");
  }

  public onCellClicked($event) {}
  exportedData;

  onBtFirst() {
    this.gridApi.paginationGoToFirstPage();
  }

  onBtLast() {
    this.pageIndex += 1;
    this.searchFun();
    this.gridApi.paginationSetPageSize(this.alarmsRecordSize);
  }
  onBtNext() {
    this.gridApi.paginationGoToNextPage();
  }

  onBtPrevious() {
    this.gridApi.paginationGoToPreviousPage();
  }

  /**
   *
   * @param content To reset the search module
   */
  resetSearch(searchForm) {
    searchForm.form.reset();
    this.startDt = undefined;
    this.endDt = undefined;
    this.dateRange = undefined;
    this.selectedDateRange = undefined;
    this.fromDate = undefined;
    this.toDate = undefined;
    this.hoveredDate = undefined;
    this.filterSearchList = [];
    this.selectedRegion = [];
    this.selectedZone = [];
    this.selectedCluster = [];
    this.selectedSeverity = [];
    this.selectedAlrmDispMode = [];
    this.selectedSiteType = [];
    this.selectedCategoryType = [];
    this.selectedSiteClass = [];
    this.selectedEnergyClass = [];
    this.selectedCoolingClass = [];
    this.selectedAlarm = [];
    this.selectedSite = [];
    this.fieldsCounter = [];
    this.additionalFieldLabel = "Need More ?";
    this.selectedPowersource = [];
    this.cannotAdd = "";
    this.filterSearchList = [];
    this.selectedOrder = [];
    this.searchFun();
  }
  /**
   * To open the Search Modal
   * @param content
   */

  searchSend() {
    this.firstRecordSize = 0;
    this.gridData = [];
    this.gridData1 = [];
    this.rowData = [];
    this.columnDefs = [];
    this.headers = [];

    if (this.selectedSortBy && this.selectedOrder.length == 0) {
      Swal.fire({
        text: "Please select Order By",
        icon: "warning",
      });
      return false;
    }
    if (this.selectedOrder.length && this.selectedSortBy == undefined) {
      Swal.fire({
        text: "Please select Sort By",
        icon: "warning",
      });
      return false;
    }
    this.modalService.dismissAll("searchClick");

    if (
      this.fieldsCounter.length == this.selectedadditonalFields.length &&
      this.fieldsCounter.length == this.selectedadditonalFieldsFilter.length &&
      this.fieldsCounter.length == this.selectedadditonalFieldsVal.length
    ) {
      this.filterSearchList = [];
      this.searchFun();
      this.cannotAdd = "";
      this.modalService.dismissAll("searchClick");
    } else {
      this.cannotAdd = "Please fill all the fields !!!";
    }
  }

  cardDataLastStatus(fmid, url) {
    this.showCountLoader = true;
    let getDataJson;
    getDataJson = {
      fmID: fmid,

      PageIndex: this.pageIndex,
      RecordPerPage: this.recordsPerRequest,
      FromDateTime: this.startDt,
      ToDateTime: this.endDt,
      RegionID: this.selectedRegion.toString().replace(/[\[\]']+/g, '"'),
      ZoneID: this.selectedZone.toString().replace(/[\[\]']+/g, '"'),
      ClusterID: this.selectedCluster.toString().replace(/[\[\]']+/g, '"'),
      SeverityID: this.selectedSeverity.toString().replace(/[\[\]']+/g, '"'),
      AlarmDisplayMode:
        this.selectedAlrmDispMode.toString().replace(/[\[\]']+/g, '"') == "2"
          ? "1,0"
          : this.selectedAlrmDispMode.toString().replace(/[\[\]']+/g, '"'),
      SiteTypeID: this.selectedSiteType.toString().replace(/[\[\]']+/g, '"'),
      alCategoryID: this.selectedCategoryType
        .toString()
        .replace(/[\[\]']+/g, '"'),
      SiteClassifID: this.selectedSiteClass
        .toString()
        .replace(/[\[\]']+/g, '"'),
      EnergyClassifID: this.selectedEnergyClass
        .toString()
        .replace(/[\[\]']+/g, '"'),
      CoolingClassifID: this.selectedCoolingClass
        .toString()
        .replace(/[\[\]']+/g, '"'),
      AlrID: this.selectedAlarm,
      SiteID: this.selectedSite.toString().replace(/[\[\]']+/g, '"'),
      PowerSource: this.selectedPowersource
        .toString()
        .replace(/[\[\]']+/g, '"'),
      recentflag: this.recentAlarms,
      outageflag: this.outageAlarms,
    };

    getDataJson = this.http
      .post(this.urlAuthentication.alarmLogUrl + url, getDataJson)
      .subscribe(
        (res) => {
          this.showCountLoader = false;
          this.openAlrmCount = 0;
          this.criticalAlarmCount = 0;
          this.majorAlarmCount = 0;
          this.minorAlarmCount = 0;
          this.outageAlrmCount = 0;
          this.recentAlrmCount = 0;
          this.totalAlarmCount = 0;
          this.cardcount = 0;
          let respCountData = res.response[0].data[0];

          this.openAlrmCount =
            respCountData.OpenCount == "" ? 0 : respCountData.OpenCount;
          this.criticalAlarmCount =
            respCountData.CriticalCount == "" ? 0 : respCountData.CriticalCount;
          this.majorAlarmCount =
            respCountData.MajorCount == "" ? 0 : respCountData.MajorCount;
          this.minorAlarmCount =
            respCountData.MinorCount == "" ? 0 : respCountData.MinorCount;
          this.outageAlrmCount =
            respCountData.OutageCount == "" ? 0 : respCountData.OutageCount;
          this.recentAlrmCount =
            respCountData.RecentCount == "" ? 0 : respCountData.RecentCount;
          this.totalAlarmCount =
            respCountData.TotalCount == "" ? 0 : respCountData.TotalCount;
          this.cardcount = this.openAlrmCount;
        },
        (error) => {
          this.showCountLoader = false;
          console.error(error);
        },
      );
  }

  getOrderByData(headers) {
    this.orderByData = [];
    let groupedHeader = headers;
    groupedHeader.forEach((column) => {
      if (column.hide === "false") {
        this.orderByData.push({
          arrayID: column.arrayID.toString(),
          headerTooltip: column.headerTooltip,
        });
      }
    });
  }

  hasFilters = 0;

  searchFun() {
    this.disablelastbutton = true;
    this.selectedSeverity;
    this.advsearchArr = [];
    this.filterSearchList = [];
    if (this.fieldsCounter.length > 0) {
      for (let i = 0; i <= this.fieldsCounter.length; i++) {
        if (
          this.selectedadditonalFields[i] != undefined &&
          this.selectedadditonalFieldsFilter[i] != undefined &&
          this.selectedadditonalFieldsVal[i] != undefined
        ) {
          this.advsearchArr.push({
            FieldID: this.selectedadditonalFields[i],
            FieldOperator: this.selectedadditonalFieldsFilter[i],
            fieldValue: this.selectedadditonalFieldsVal[i],
          });
        }
      }
    }
    if (!this.selectedRegion) {
      this.selectedRegion = [];
    }
    if (!this.selectedZone) {
      this.selectedZone = [];
    }
    if (!this.selectedCluster) {
      this.selectedCluster = [];
    }
    if (!this.selectedSite) {
      this.selectedSite = [];
    }
    if (!this.selectedAlrmDispMode) {
      this.selectedAlrmDispMode = [];
    }

    if (this.startDt && this.endDt) {
      this.filterSearchList.push({
        id: 0,
        name: "Date Range",
        value: this.dateRange,
      });
    }

    if (this.selectedRegion.length > 0) {
      if (this.selectedRegion.length == 1) {
        var searchRegion = this.searchRegion.find(
          (x) => x.RegionID == this.selectedRegion,
        );
        this.filterSearchList.push({
          id: 2,
          name: "Region",
          value: searchRegion.RegionName,
        });
      } else {
        const existingItem = this.filterSearchList.find(
          (item) =>
            item.id === 2 &&
            item.name === "Region" &&
            item.value === "Selected " + this.selectedRegion.length + " values",
        );

        if (!existingItem) {
          this.filterSearchList.push({
            id: 2,
            name: "Region",
            value: "Selected " + this.selectedRegion.length + " values",
          });
        }
      }
    }

    if (this.selectedZone.length > 0) {
      if (this.selectedZone.length == 1) {
        var searchZone = this.searchZone.find(
          (x) => x.ZoneID == this.selectedZone,
        );
        this.filterSearchList.push({
          id: 3,
          name: "Zone",
          value: searchZone.ZoneName,
        });
      } else {
        this.filterSearchList.push({
          id: 3,
          name: "Zone",
          value: "Selected " + this.selectedZone.length + " values",
        });
      }
    }
    if (this.selectedCluster.length > 0) {
      if (this.selectedCluster.length == 1) {
        var searchCluster = this.searchCluster.find(
          (x) => x.ClusterID == this.selectedCluster,
        );
        this.filterSearchList.push({
          id: 4,
          name: "Cluster",
          value: searchCluster.ClusterName,
        });
      } else {
        this.filterSearchList.push({
          id: 4,
          name: "Cluster",
          value: "Selected " + this.selectedCluster.length + " values",
        });
      }
    }
    if (this.selectedSeverity.length > 0) {
      if (this.selectedSeverity.length == 1) {
        var searchSeverity = this.searchSeverity.find(
          (x) => x.id == this.selectedSeverity,
        );
        this.filterSearchList.push({
          id: 5,
          name: "Severity",
          value: searchSeverity.severity,
        });
      } else {
        this.filterSearchList.push({
          id: 5,
          name: "Severity",
          value: "Selected " + this.selectedSeverity.length + " values",
        });
      }
    }
    if (this.selectedAlrmDispMode.length > 0) {
      if (this.selectedAlrmDispMode.length == 1) {
        var AlrmDispMode = this.searchAlrmDispMode.find(
          (x) => x.id == this.selectedAlrmDispMode,
        );

        this.filterSearchList.push({
          id: 6,
          name: "Alarm Display Mode",
          value: AlrmDispMode.mode,
        });
      } else {
      }
    }
    if (this.selectedSiteType.length > 0) {
      if (this.selectedSiteType.length == 1) {
        var searchSiteType = this.searchSiteType.find(
          (x) => x.id == this.selectedSiteType,
        );
        this.filterSearchList.push({
          id: 7,
          name: "Site Type",
          value: searchSiteType.siteType,
        });
      } else {
        this.filterSearchList.push({
          id: 7,
          name: "Site Type",
          value: "Selected " + this.selectedSiteType.length + " values",
        });
      }
    }
    if (this.selectedCategoryType.length > 0) {
      if (this.selectedCategoryType.length == 1) {
        var searchCategoryType = this.categoryName.find(
          (x) => x.categoryID == this.selectedCategoryType[0],
        );
        this.filterSearchList.push({
          id: 17,
          name: "Alarm Category",
          value: searchCategoryType
            ? searchCategoryType.categoryName
            : this.selectedCategoryType[0],
        });
      } else {
        this.filterSearchList.push({
          id: 17,
          name: "Alarm Category",
          value: "Selected " + this.selectedCategoryType.length + " values",
        });
      }
    }
    if (this.selectedSiteClass.length > 0) {
      if (this.selectedSiteClass.length == 1) {
        var searchSiteClass = this.searchSiteClass.find(
          (x) => x.ID == this.selectedSiteClass,
        );
        this.filterSearchList.push({
          id: 8,
          name: "Site Classification",
          value: searchSiteClass.SiteClassName,
        });
      } else {
        this.filterSearchList.push({
          id: 8,
          name: "Site Classification",
          value: "Selected " + this.selectedSiteClass.length + " values",
        });
      }
    }
    if (this.selectedEnergyClass.length > 0) {
      if (this.selectedEnergyClass.length == 1) {
        var searchEnergyClass = this.searchEnergyClass.find(
          (x) => x.ID == this.selectedEnergyClass,
        );
        this.filterSearchList.push({
          id: 9,
          name: "Energy Classification",
          value: searchEnergyClass.EnerClassName,
        });
      } else {
        this.filterSearchList.push({
          id: 9,
          name: "Energy Classification",
          value: "Selected " + this.selectedEnergyClass.length + " values",
        });
      }
    }
    if (this.selectedCoolingClass.length > 0) {
      if (this.selectedCoolingClass.length == 1) {
        var searchCoolingClass = this.searchCoolingClass.find(
          (x) => x.ID == this.selectedCoolingClass,
        );
        this.filterSearchList.push({
          id: 10,
          name: "Cooling Classification",
          value: searchCoolingClass.CoolClassName,
        });
      } else {
        this.filterSearchList.push({
          id: 10,
          name: "Cooling Classification",
          value: "Selected " + this.selectedCoolingClass.length + " values",
        });
      }
    }
    if (this.selectedAlarm.length > 0) {
      if (this.selectedAlarm.length == 1) {
        var searchAlarm = this.searchAlarmList.find(
          (x) => x.Alarmpin == this.selectedAlarm,
        );
        this.filterSearchList.push({
          id: 11,
          name: "Alarm",
          value: searchAlarm.Alarmname,
        });
      } else {
        this.filterSearchList.push({
          id: 11,
          name: "Alarm",
          value: "Selected " + this.selectedAlarm.length + " values",
        });
      }
    }
    if (this.selectedSite.length > 0) {
      if (this.selectedSite.length == 1) {
        var searchSite = this.searchSite.find(
          (x) => x.SiteID == this.selectedSite,
        );
        this.filterSearchList.push({
          id: 12,
          name: "Site ID| Site Name",
          value: searchSite.siteId_Name,
        });
      } else {
        this.filterSearchList.push({
          id: 12,
          name: "Site ID| Site Name",
          value: "Selected " + this.selectedSite.length + " values",
        });
      }
    }

    if (this.advsearchArr.length > 0) {
      let searchAdvFilterName;
      this.selectedadditonalFields.forEach((element) => {
        searchAdvFilterName = this.additionalFields.find(
          (x) => x.fieldId == element,
        );
      });

      if (
        this.selectedadditonalFields.length == 1 &&
        this.selectedadditonalFieldsFilter.length == 1 &&
        this.selectedadditonalFieldsVal.length == 1
      ) {
        this.filterSearchList.push({
          id: 13,
          name: "More Filters",
          value:
            searchAdvFilterName.fieldName +
            " " +
            this.selectedadditonalFieldsFilter[0] +
            " " +
            this.selectedadditonalFieldsVal[0],
        });
      } else {
        let index = this.selectedadditonalFields.length;
        this.filterSearchList.push({
          id: 13,
          name: "More Filters",
          value: "Selected " + index + " values",
        });
      }
    }
    if (this.selectedPowersource.length > 0) {
      if (this.selectedPowersource.length == 1) {
        var searchPowersource = this.searchPowersource.find(
          (x) => x.id == this.selectedPowersource,
        );
        this.filterSearchList.push({
          id: 14,
          name: "Power Source",
          value: searchPowersource.powerSource,
        });
      } else {
        this.filterSearchList.push({
          id: 14,
          name: "Power Source",
          value: "Selected " + this.selectedPowersource.length + " values",
        });
      }
    }

    if (this.recentAlarms == "1") {
      this.filterSearchList.push({
        id: 15,
        name: "Recent",
        value: "Alarms",
      });
    }
    if (this.outageAlarms == "1") {
      this.filterSearchList.push({
        id: 16,
        name: "Outage",
        value: "Alarms",
      });
    }

    if (this.filterSearchList.length == 0 && this.pageIndex == 1) {
      this.hasFilters = 0;
      this.gridData = [];
      this.gridData1 = [];
      this.rowData = [];
    } else {
      this.hasFilters = 1;
    }
    if (!this.startDt || !this.endDt) {
      this.alarmFmID = "300";
      this.countFmID = 302;
      this.alarmURL = this.apiUrl.alarmlastStatusUrl;
      this.countURL = this.apiUrl.alarmCountLastStatus;
    } else {
      this.alarmFmID = "301";
      this.countFmID = 303;
      this.alarmURL = this.apiUrl.alarmRecordsUrl;
      this.countURL = this.apiUrl.alarmCountRecords;
    }

    let searchJson = {
      fmID: this.alarmFmID,
      PageIndex: this.pageIndex,
      RecordPerPage: this.recordsPerRequest,
      FromDateTime: this.startDt,
      ToDateTime: this.endDt,
      RegionID: this.selectedRegion.toString().replace(/[\[\]']+/g, '"'),
      ZoneID: this.selectedZone.toString().replace(/[\[\]']+/g, '"'),
      ClusterID: this.selectedCluster.toString().replace(/[\[\]']+/g, '"'),
      SeverityID: this.selectedSeverity.toString().replace(/[\[\]']+/g, '"'),
      AlarmDisplayMode:
        this.selectedAlrmDispMode.toString().replace(/[\[\]']+/g, '"') == "2"
          ? "1,0"
          : this.selectedAlrmDispMode.toString().replace(/[\[\]']+/g, '"'),
      SiteTypeID: this.selectedSiteType.toString().replace(/[\[\]']+/g, '"'),
      alCategoryID: this.selectedCategoryType
        .toString()
        .replace(/[\[\]']+/g, '"'),
      SiteClassifID: this.selectedSiteClass
        .toString()
        .replace(/[\[\]']+/g, '"'),
      EnergyClassifID: this.selectedEnergyClass
        .toString()
        .replace(/[\[\]']+/g, '"'),
      CoolingClassifID: this.selectedCoolingClass
        .toString()
        .replace(/[\[\]']+/g, '"'),
      AlrID: this.selectedAlarm,
      SiteID: this.selectedSite.toString().replace(/[\[\]']+/g, '"'),
      PowerSource: this.selectedPowersource
        .toString()
        .replace(/[\[\]']+/g, '"'),
      recentflag: this.recentAlarms,
      outageflag: this.outageAlarms,
      Export: 0,
      Order: this.selectedOrder.length ? "Order By" : "",
      OrderBy: this.selectedOrder.toString().replace(/[\[\]']+/g, '"'),
      Sort: this.selectedOrder.length ? this.selectedSortBy : "",
    };

    if (this.selectedOrder.length > 0) {
      if (this.selectedOrder.length == 1) {
        var searchOrderBy = this.orderByData.find(
          (x) => x.arrayID == this.selectedOrder,
        );
        this.filterSearchList.push({
          name: "Order By",
          value: searchOrderBy.headerTooltip,
        });
      } else {
        this.filterSearchList.push({
          name: "Order By",
          value: "Selected " + this.selectedOrder.length + " values",
        });
      }
    }

    if (this.selectedSortBy) {
      var searchSortFilter = this.sortByFilter.find(
        (x) => x.id == this.selectedSortBy,
      );
      this.filterSearchList.push({
        name: "Sort By",
        value: searchSortFilter.name,
      });
    }

    if (this.pageIndex == 1) {
      this.cardDataLastStatus(this.countFmID, this.countURL);
    }
    this.http
      .post(this.urlAuthentication.alarmLogUrl + this.alarmURL, searchJson)
      .subscribe(
        (res) => {
          this.gridData1 = [];
          this.showGridLoader = false;
          const resp = res.response[0];
          this.jsonTitle = res.response[0].Header.title;
          if (this.headers.length == 0) {
            this.groupHeaders = resp.Header.columns;
            this.getOrderByData(this.groupHeaders);
            let groupedData = this.groupHeader.transform(this.groupHeaders);
            this.headers = groupedData;
            this.headers.push({
              headerName: "Action",
              field: "action",
              cellRenderer: "actionRenderer",
              width: 100,
              chartDataType: "excluded",
              suppressSorting: true,
              suppressMenu: true,
              pinned: "right",
              suppressColumnsToolPanel: true,
              suppressResize: false,
              maxWidth: 100,
            });
            this.columnDefs = this.headers;
          }
          this.gridData1 = resp.data;
          if (this.gridData1.length < this.recordsPerRequest) {
            this.disablelastbutton = true;
          } else {
            this.disablelastbutton = false;
          }

          for (let i = 0; i < this.gridData1.length; i++) {
            this.gridData.push(this.gridData1[i]);
          }

          if (this.gridData && this.gridData.length > 0) {
            this.createRowData();
          } else {
            this.rowData = [];
          }
          if (this.startDt || this.endDt) {
            this.disableExport = true;
          } else {
            this.disableExport = false;
          }

          this.gridApi.setRowData(this.rowData);
          this.gridApi.setFilterModel(null);
        },
        (error) => {
          console.error(error);
          this.showGridLoader = false;
        },
      );
  }

  onCategoryTypeChange() {
    if (this.selectedCategoryType && this.selectedCategoryType.length > 0) {
      this.searchAlarmList = this.searchAlarmListAll.filter((alarm) =>
        this.selectedCategoryType.includes(alarm.alCategoryID),
      );
      this.selectedAlarm = this.selectedAlarm.filter((pin) =>
        this.searchAlarmList.some((alarm) => alarm.Alarmpin === pin),
      );
    } else {
      this.searchAlarmList = this.searchAlarmListAll;
    }
  }

  createRowData() {
    this.rowData = this.gridData;
  }
}
